module.exports = __webpack_public_path__ + "bfac37bb4c63c8a4ecebc01329c36444.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-7.png
// module id = 2683
// module chunks = 0